/* ============
 * Mutations for the auth module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import {
    SET_LIST,
    CACHE_LIST,
    CONFIG,
    SET_PULLING_STATE,
    SET_PROMISE,
    ROUTE_HISTORY,
    LABEL_STATUS,
    LABEL_DATA,
    FRESH_LOCATION_LIST,
    SET_LOCALE,
} from "./mutation-types";

/* eslint-disable no-param-reassign */
export default {
    [CONFIG](state, data) {
        state.config = data;
        state.oldCacheKey = data.key;
        localStorage.setItem(state.keys.OLD_CACHE_KEY, data.key);
    },
    [SET_LIST](state, data) {
        localStorage.setItem(data.key, data.value);
        state[data.key] = data.value;
    },
    [FRESH_LOCATION_LIST](state, data) {
        data = data ? data : Object.keys(state.location);

        data.map((key) => {
            let generatedKey = state.generate_key(key);
            let storeData = localStorage.getItem(generatedKey);

            state[key] = storeData ? JSON.parse(storeData) : null;
        });
    },
    [CACHE_LIST](state, data) {
        state[data.key] = data.value;
    },
    [SET_PULLING_STATE](state, info) {
        let key = state.generate_key(info.url, info.params, state);

        state.inPulling[key] = info.value;
    },
    [SET_PROMISE](state, info) {
        let key = state.generate_key(info.url, info.params, state);

        state.promise[key] = info.value;
    },

    [ROUTE_HISTORY](state, payload) {
        let breadCrumb = localStorage.getItem("breadCrumb");
        const windowId = window.name;

        if (payload.meta.breadcrumbs != undefined) {
            if (payload.meta.breadcrumbs.length > 0) {
                const breadcrumbRoutes = payload.meta.breadcrumbs.map(
                    (data) => {
                        return data.route;
                    }
                );

                if (state.routeHistory.length == 0) {
                    if (!breadCrumb) {
                        breadCrumb = '{"crumb":[]}';
                        toStoreWhenLoaded(state, breadCrumb, windowId, payload);
                    } else {
                        toStoreWhenLoaded(state, breadCrumb, windowId, payload);
                    }
                } else {
                    const history = state.routeHistory.some((history) =>
                        breadcrumbRoutes.includes(history.name)
                    );

                    const routeHistory = state.routeHistory.map((data) => {
                        return data.name;
                    });

                    let searchIndex = routeHistory.lastIndexOf(payload.name);

                    if (history) {
                        if (searchIndex != -1) {
                            if ( routeHistory.indexOf(payload.name) != routeHistory.length - 1 ) {
                                // ဒါက reset ပြန်ချတာ
                                state.routeHistory = [];
                            }
                        }
                    } else {
                        state.routeHistory = [];
                    }

                    if(routeHistory.indexOf(payload.name) != routeHistory.length - 1) {
                        toStoreWhenClicked(state, breadCrumb, windowId, payload);
                    }
                }

                const count = state.routeHistory.length - 1;

                state.routeHistory.forEach((route, index) => {
                    route.url = route.meta.breadcrumbs.find(
                        (data) => data.route == route.name
                    );

                    route.isLast = index == count ? true : false;
                    // route.paramsKeys = Object.keys(route.params);
                    // route.paramsValues = Object.values(route.params);
                    // route.queryKeys = Object.keys(route.query);
                    // route.queryValues = Object.values(route.query);
                });
            }
            toWindowRemove(windowId);
        }
    },

    [LABEL_STATUS](state, payload) {
        state.labelStatus = payload;
    },

    [LABEL_DATA](state, payload) {
        state.labelData = payload;
        console.log(payload);
    },

    [SET_LOCALE](state, payload) {
        state.locale = payload;
    },
};

const toStoreWhenLoaded = (state, crumb, windowId, payload) => {
    let breadCrumbObj = JSON.parse(crumb);
    let newWindow = {};
    let oldWindowId = breadCrumbObj.crumb.map((data) => {
        return Object.keys(data);
    });

    if (!oldWindowId.flat().includes(windowId)) {
        newWindow[`${windowId}`] = [payload];
        state.routeHistory.push(payload);
        breadCrumbObj.crumb.push(newWindow);
        localStorage.setItem("breadCrumb", JSON.stringify(breadCrumbObj));
    } else {
        state.routeHistory = breadCrumbObj.crumb.find(
            (crumb) => Object.keys(crumb) == windowId
        )[`${windowId}`];
    }
    return true;
};

const toStoreWhenClicked = (state, crumb, windowId, payload) => {
    let breadCrumbObj = JSON.parse(crumb);
    // console.log(JSON.parse(JSON.stringify(breadCrumbObj)));
    state.routeHistory.push(payload);

    let currentCrumb = breadCrumbObj.crumb.find(
        (crumb) => Object.keys(crumb) == windowId
    );

    if (!currentCrumb) {
        return false;
    }

    breadCrumbObj.crumb.find((crumb) => Object.keys(crumb) == windowId)[`${windowId}`] = state.routeHistory;

    localStorage.setItem("breadCrumb", JSON.stringify(breadCrumbObj));

    return true;
};

const toWindowRemove = (windowId) => {
    let breadCrumb = localStorage.getItem("breadCrumb");

    if (breadCrumb != null) {
        let breadCrumbObj = JSON.parse(breadCrumb);
        if (breadCrumbObj.crumb.length > 0) {
            // console.log(new Date("11/30/2021, 4:25:54 AM") < new Date());

            let alive = breadCrumbObj.crumb.filter((crumb, index) => {
                if (
                    crumb[`${windowId}`] ||
                    new Date(
                        crumb[Object.keys(crumb)[0]][0].windowExpiredTime
                    ) > new Date()
                ) {
                    return crumb[Object.keys(crumb)];
                }
            });
            // console.log("alive", alive);
            // console.log("breadcrumb", breadCrumbObj.crumb);
            breadCrumbObj.crumb = alive;
            localStorage.setItem("breadCrumb", JSON.stringify(breadCrumbObj));
        }
    }
};
